import {
	MODULE_NAME,
	LOGO,
	LOGOS,
	SAVE_LOGO,
	SET_LOGO,
	SET_LOGOS,
	RELOAD_LOGOS,
	TOAST_MESSAGES_PUSH,
	LOGOS_HISTORY,
	SET_LOGOS_HISTORY
} from './logos-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

const baseApi = `/${MODULE_NAME}`;

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[LOGO]: null,
		[LOGOS]: {},
		[RELOAD_LOGOS]: false,
		[LOGOS_HISTORY]: {}
	},
	mutations: {
		//beta-features
		[RELOAD_LOGOS](state, value) {
			state[RELOAD_LOGOS] = value;
		},
		[SET_LOGOS](state, obj) {
			state[LOGOS] = obj;
		},
		[SET_LOGO](state, obj) {
			state[LOGO] = obj;
		},

		//transactions
		[SET_LOGOS_HISTORY](state, obj) {
			state[LOGOS_HISTORY] = obj;
		}
	},
	actions: {
		async [SAVE_LOGO]({ dispatch, commit }, obj) {
			let action = 'added';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Beta Feature successfully ${action}.`
				};
				dispatch(SET_LOGO, null);
				commit(RELOAD_LOGOS, true);
			};
			let result;
			if (obj.id) {
				action = 'edited';
				result = await api
					.put(`${baseApi}/${obj.id}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch()
					.finally(() => {
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					});
			}
			return result;
		},
		async [SET_LOGOS]({ commit }, params) {
			commit(SET_LOGOS, {});

			const results = await api.get(buildRoute(baseApi, params));

			commit(SET_LOGOS, results);
			commit(RELOAD_LOGOS, false);
		},

		async [SET_LOGO]({ commit }, id) {
			if (!id) {
				commit(SET_LOGOS, {});
				return;
			}
			const result = await api.get(`${baseApi}/${id}`);
			commit(SET_LOGO, result);
		},
		//transactions
		async [SET_LOGOS_HISTORY]({ commit }, params) {
			commit(SET_LOGOS_HISTORY, {});

			const results = await api.get(
				buildRoute(`${baseApi}/versionhistory`, params)
			);

			commit(SET_LOGOS_HISTORY, results);
		}
	},
	getters: {
		[LOGO]: state => state[LOGO],
		[LOGOS]: state => state[LOGOS],
		[RELOAD_LOGOS]: state => state[RELOAD_LOGOS],
		[LOGOS_HISTORY]: state => state[LOGOS_HISTORY]
	}
};
